import React, { useState, useEffect } from "react";
import Header from "../../components/UserHeaer";
import Carousel from "./components/Carousel";
import { BiBed, BiBath, BiWifi } from "react-icons/bi";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { RiSearch2Line, RiMapPinLine, RiArrowDownSLine, RiArrowUpSLine, RiWallet3Line } from 'react-icons/ri';
import { BsPeople } from 'react-icons/bs';
import { Menu } from '@headlessui/react';

function Home() {
  const [posts, setPosts] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [isOpen2, setIsOpen2] = useState(false);
  const [isOpen3, setIsOpen3] = useState(false);
  const [minPrice, setMinPrice] = useState(null);
  const [maxPrice, setMaxPrice] = useState(null);
  const [address, setAddress] = useState('Địa chỉ');
  const [people, setPeople] = useState(null);
  const [selectedPrice, setSelectedPrice] = useState('Giá tiền');
  const [selectedPeople, setSelectedPeople] = useState('Số người');
  const token = localStorage.getItem("Token");
  const navigate = useNavigate();
  let url = `https://trototbe.azurewebsites.net/api/Posts/all?Status=1`;

  const fetchPostData = () => {
    if (address !== 'Địa chỉ' && address !== 'Tất cả') {
      url += `&Address=${address}`;
    }
    if (minPrice != null) {
      url += `&MinPrice=${minPrice}`;
    }
    if (maxPrice != null) {
      url += `&MaxPrice=${maxPrice}`;
    }
    if (people != null) {
      url += `&People=${people}`;
    }
    let config = {
      method: "GET",
      maxBodyLength: Infinity,
      url: url,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    axios
      .request(config)
      .then((response) => {
        console.log("data", JSON.stringify(response.data));
        setPosts(response?.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const PostDetails = (id) => {
    navigate('/post-details', { state: { postId: id } });
  }

  const handlePriceClick = (min, max, selected) => {
    setMinPrice(min);
    setMaxPrice(max);
    setSelectedPrice(selected);
  }

  const handlePeopleClick = (number, selected) => {
    setPeople(number);
    setSelectedPeople(selected);
  }

  useEffect(() => {
    if (localStorage) {
      var role = localStorage.getItem("Role");
      if (role !== "User" && role !== "Vip") {
        navigate("/");
      } else {
        fetchPostData();
      }
    }
  }, []);

  return (
    <div className="w-full">
      <Header />
      <Carousel />
      <section className="h-full max-h-[640px] mb-8 xl:mb-24">
        <div className="flex flex-col lg:flex-row">
          <div className="lg:ml-8 xl:ml-[135px] flex flex-col items-center lg:items-start text-center lg:text-left justify-center
                    flex-1 px-4 lg:px-0">
            <h1 className="text-4xl lg:text-[58px] font-semibold leading-none mb-6">
              <span className="text-violet-700">Rent</span> Your Dream Room With Us.</h1>
          </div>
          <div className="hidden flex-1 lg:flex justify-end items-end ml-2">
            <img className="rounded-tl-2xl" src="https://images.unsplash.com/photo-1586023492125-27b2c045efd7?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=958&q=80" alt="" />
          </div>
        </div>
        <div className="px-[30px] py-6 max-w-[1170px] mx-auto flex flex-col lg:flex-row justify-between gap-4 lg:gap-x-3 relative  
                z-50 lg:-top-4 lg:shadow-lg bg-white lg:bg-transparent lg:backdrop-blur rounded-lg">
          <Menu as='div' className="w-full lg:max-w-[296px] cursor-pointer relative">
            <Menu.Button className="flex h-[64px] items-center px-[18px] border rounded-lg w-full text-left"
              onClick={() => setIsOpen(!isOpen)}>
              <RiMapPinLine className="text-2xl mr-[18px] text-violet-700" />
              <div>
                {address === 'Địa chỉ' ? (
                  <div className="text-[15px] font-medium leading-tight">Địa chỉ</div>
                ) : (
                  <div className="text-[15px] font-medium leading-tight">{address}</div>
                )}
                <div className="text-[13px]">Chọn địa chỉ</div>
              </div>
              {
                isOpen ? (
                  <RiArrowUpSLine className="text-2xl text-violet-700 ml-auto" />
                ) : (
                  <RiArrowDownSLine className="text-2xl text-violet-700 ml-auto" />
                )
              }
            </Menu.Button>
            <Menu.Items className="px-6 py-8 text-[15px] bg-[#f6f3e9] space-y-6 shadow-md absolute w-full z-10 list-none 
                        rounded-b-lg">
              <Menu.Item as="li" onClick={() => setAddress("Tất cả")}
                className="cursor-pointer hover:text-violet-700 transition">Tất cả</Menu.Item>
              <Menu.Item as="li" onClick={() => setAddress("Hồ Chí Minh")}
                className="cursor-pointer hover:text-violet-700 transition">Hồ Chí Minh</Menu.Item>
              <Menu.Item as="li" onClick={() => setAddress("Đà Nẵng")}
                className="cursor-pointer hover:text-violet-700 transition">Đà Nẵng</Menu.Item>
              <Menu.Item as="li" onClick={() => setAddress("Hà Nội")}
                className="cursor-pointer hover:text-violet-700 transition">Hà Nội</Menu.Item>
            </Menu.Items>
          </Menu>
          <Menu as='div' className="w-full lg:max-w-[296px] cursor-pointer relative">
            <Menu.Button className="flex h-[64px] items-center px-[18px] border rounded-lg w-full text-left"
              onClick={() => setIsOpen2(!isOpen2)}>
              <BsPeople className="text-2xl mr-[18px] text-violet-700" />
              <div>
                {selectedPeople === 'Số người' ? (
                  <div className="text-[15px] font-medium leading-tight">Số người</div>
                ) : (
                  <div className="text-[15px] font-medium leading-tight">{selectedPeople}</div>
                )}
                <div className="text-[13px]">Chọn số người</div>
              </div>
              {
                isOpen2 ? (
                  <RiArrowUpSLine className="text-2xl text-violet-700 ml-auto" />
                ) : (
                  <RiArrowDownSLine className="text-2xl text-violet-700 ml-auto" />
                )
              }
            </Menu.Button>
            <Menu.Items className="px-6 py-8 text-[15px] bg-[#f6f3e9] space-y-6 shadow-md absolute w-full z-50 list-none 
                        rounded-b-lg">
              <Menu.Item as="li" onClick={() => handlePeopleClick(null, 'Tất cả')}
                className="cursor-pointer hover:text-violet-700 transition">Tất Cả</Menu.Item>
              <Menu.Item as="li" onClick={() => handlePeopleClick(1, '1 người')}
                className="cursor-pointer hover:text-violet-700 transition">1 người</Menu.Item>
              <Menu.Item as="li" onClick={() => handlePeopleClick(2, '2 người')}
                className="cursor-pointer hover:text-violet-700 transition">2 người</Menu.Item>
              <Menu.Item as="li" onClick={() => handlePeopleClick(3, '3 người')}
                className="cursor-pointer hover:text-violet-700 transition">3 người</Menu.Item>
            </Menu.Items>
          </Menu>
          <Menu as='div' className="w-full lg:max-w-[296px] cursor-pointer relative">
            <Menu.Button className="flex h-[64px] items-center px-[18px] border rounded-lg w-full text-left"
              onClick={() => setIsOpen3(!isOpen3)}>
              <RiWallet3Line className="text-2xl mr-[18px] text-violet-700" />
              <div>
                {selectedPrice === 'Giá tiền' ? (
                  <div className="text-[15px] font-medium leading-tight">Giá tiền</div>
                ) : (
                  <div className="text-[15px] font-medium leading-tight">{selectedPrice}</div>
                )}
                <div className="text-[13px]">Chọn giá tiền</div>
              </div>
              {
                isOpen3 ? (
                  <RiArrowUpSLine className="text-2xl text-violet-700 ml-auto" />
                ) : (
                  <RiArrowDownSLine className="text-2xl text-violet-700 ml-auto" />
                )
              }
            </Menu.Button>
            <Menu.Items className="px-6 py-8 text-[15px] bg-[#f6f3e9] space-y-6 shadow-md absolute w-full z-50 list-none 
                        rounded-b-lg">
              <Menu.Item as="li" onClick={() => handlePriceClick(null, null, 'Tất cả')}
                className="cursor-pointer hover:text-violet-700 transition">Tất Cả</Menu.Item>
              <Menu.Item as="li" onClick={() => handlePriceClick(1000000, 2000000, '1M - 2M VND')}
                className="cursor-pointer hover:text-violet-700 transition">1M - 2M VND</Menu.Item>
              <Menu.Item as="li" onClick={() => handlePriceClick(2000000, 3000000, '2M - 3M VND')}
                className="cursor-pointer hover:text-violet-700 transition">2M - 3M VND</Menu.Item>
              <Menu.Item as="li" onClick={() => handlePriceClick(3000000, 5000000, '3M - 5M VND')}
                className="cursor-pointer hover:text-violet-700 transition">3M - 5M VND</Menu.Item>
            </Menu.Items>
          </Menu>
          <button onClick={fetchPostData} className="bg-violet-700 hover:bg-violet-800 transition w-full lg:max-w-[162px] h-16 rounded-lg flex 
                    justify-center items-center text-white text-lg">
            <RiSearch2Line /></button>
        </div>
      </section>
      <br></br>
      <br></br>
      <br></br>
      <section className="mb-20">
        <div className="container mx-auto relative z-0">
          {posts?.length > 0 && (
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-2">
              {posts?.map(post => (
                <button key={post?.postId} onClick={() => PostDetails(post?.postId)} className="transform transition-all mb-10 hover:scale-105">
                  <div
                    className="bg-white shadow-lg p-5 rounded-lg rounded-tl-[90px] w-full max-w-[400px] mx-auto cursor-pointer 
    hover:shadow-2xl transition"
                  >
                    <div> <img
                      className="rounded-tl-[90px] rounded-br-[90px] mb-8 h-[300px] w-full object-cover"
                      src={post?.image}
                      alt=""
                    /></div>
                    <div className="mb-4 flex gap-x-2 text-sm">
                      <div className="bg-green-500 rounded-full text-white px-3">
                        {post?.typeName}
                      </div>
                      <div className="bg-violet-500 rounded-full text-white px-3">
                        {post?.address}
                      </div>
                    </div>
                    {post?.title.length > 20 ? (
                      <div className=" px-3 text-lg font-semibold ">
                        {post?.title.substring(0, 20)}...
                      </div>
                    ) : (
                      <div className=" px-3 text-lg font-semibold ">
                        {post?.title}
                      </div>
                    )}
                    <div className="flex gap-x-4 my-4 justify-center">
                      <div className="flex items-center text-gray-600 gap-1">
                        <div className="text-[20px]">
                          <BiBed />
                        </div>
                        <div>{post?.beds}</div>
                      </div>
                      <div className="flex items-center text-gray-600 gap-1">
                        <div className="text-[20px]">
                          <BiBath />
                        </div>
                        <div>{post?.baths}</div>
                      </div>
                      <div className="flex items-center text-gray-600 gap-1">
                        <div className="text-[20px]">
                          <BiWifi />
                        </div>
                        <div>4G</div>
                      </div>
                    </div>
                    <div className="text-lg font-semibold text-violet-600 mb-4">
                      Giá tiền: {post?.price} vnd
                    </div>
                    <div className="text-lg font-semibold text-violet-600 mb-4">
                      Số người: {post?.numberOfPeople} người
                    </div>
                  </div>
                </button>
              ))}
            </div>
          )}
        </div>
      </section>
    </div>
  );
}

export default Home;
